import { describeResource } from '@siteless/resource';
import { database } from '../../config/firebase';
import z from 'zod';
import { uniq } from 'lodash';
import { collection, doc, getDoc, getDocs } from 'firebase/firestore';

export let oneLeagueResourceSchema = z.union([
  z.null(),
  z.object({
    id: z.string(),
    strictMode: z.optional(z.boolean()),
    name: z.string(),
    createdByUserId: z.string(),
    ownerUserId: z.string(),
    joinLinkId: z.string(),
    memberUserIds: z.array(z.string()),
    createdAt: z.object({
      nanoseconds: z.number(),
      seconds: z.number(),
    }),
  }),
]);

export type OneLeagueResourceType = z.infer<typeof oneLeagueResourceSchema>;

export let OneLeagueResource = describeResource('OneLeague', {
  get: async (leagueId?: string) => {
    if (!leagueId) return null;

    let data =
      (await getDoc(doc(database, 'leagues', leagueId))).data() || null;

    if (data === null) return null;

    let legacyMemberIds = data.memberUserIds || [];

    let memberUserIds: string[] = [];

    (
      await getDocs(
        collection(database, 'leagues', leagueId, 'leagueMemberUserIds'),
      )
    ).forEach(doc => {
      memberUserIds.push(doc.data().userId);
    });

    return oneLeagueResourceSchema.parse({
      ...data,
      id: leagueId,
      memberUserIds: uniq(memberUserIds.concat(legacyMemberIds)),
    });
  },
});

export default OneLeagueResource;
